import { render, staticRenderFns } from "./shareForm.vue?vue&type=template&id=be4d7f74&scoped=true"
import script from "./shareForm.vue?vue&type=script&lang=js"
export * from "./shareForm.vue?vue&type=script&lang=js"
import style0 from "./shareForm.vue?vue&type=style&index=0&id=be4d7f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4d7f74",
  null
  
)

export default component.exports